var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0090FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.77 8h-5.385c-.595 0-1.077.471-1.077 1.053 0 .581.482 1.052 1.077 1.052h5.384c.595 0 1.077.472 1.077 1.053v13.684c0 .582-.482 1.053-1.077 1.053H3.231c-.595 0-1.077-.471-1.077-1.053V11.158c0-.581.482-1.053 1.077-1.053h5.384c.595 0 1.077-.471 1.077-1.052C9.692 8.47 9.21 8 8.615 8H3.231C1.446 8 0 9.414 0 11.158v13.684C0 26.586 1.446 28 3.23 28h21.54c1.784 0 3.23-1.414 3.23-3.158V11.158C28 9.414 26.554 8 24.77 8z",
    transform: "translate(-926 -106) translate(251 77) translate(35 17) translate(640 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.669 14.973c-.421-.392-1.088-.392-1.508 0l-3.577 3.45V1.048C14.584.469 14.098 0 13.5 0c-.6 0-1.085.469-1.085 1.048v17.375l-3.575-3.45c-.43-.402-1.118-.39-1.534.026-.407.406-.407 1.05 0 1.455l5.427 5.238c.423.41 1.11.41 1.534.002l.002-.002 5.427-5.238c.417-.416.405-1.079-.026-1.48z",
    transform: "translate(-926 -106) translate(251 77) translate(35 17) translate(640 12)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.39d45ff18dfde6a21e47118fb378cdd2.svg";
export { ForwardRef as ReactComponent };